/**
 * Where "the dashboard" is for a given user.
 *
 * There is no single dashboard URL in this app: platform admins, org
 * admins/owners, and crew each have their own, and a freelancer can be CREW in
 * one organization and ADMIN in another. Anything that needs to say "go to your
 * dashboard" without knowing the reader's role has to resolve it here.
 *
 * That includes email, which cannot resolve anything at send time — hence the
 * `/dashboard` route, which is this function behind a redirect.
 */

export interface DashboardUser {
  platformRole?: string | null;
}

export interface DashboardOrg {
  role?: string | null;
}

export function resolveDashboardPath(
  user: DashboardUser | null | undefined,
  currentOrg: DashboardOrg | null | undefined
): string {
  if (user?.platformRole === 'PLATFORM_ADMIN') return '/platform';
  // No org context yet (or a platform admin with no membership): /admin is the
  // safe landing, and ProtectedRoute bounces anyone who does not belong there.
  if (!currentOrg) return '/admin';
  return currentOrg.role === 'CREW' ? '/crew' : '/admin';
}
